import React from 'react';
import { Flex } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { useVerticalMode } from '../../controllers/feature-context.tsx';

export const JQLBuilderContainer = ({ children }: { children: React.ReactNode }) => {
	const verticalMode = useVerticalMode();

	if (verticalMode) {
		return (
			<Flex as="ul" direction="column" xcss={jqlBuilderContainerStyles.container}>
				{children}
			</Flex>
		);
	}

	return children;
};

const jqlBuilderContainerStyles = cssMap({
	container: {
		paddingLeft: token('space.0'),
		width: '100%',
	},
});
